/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'../../../lib/@waca/dashboard-common/dist/core/UniqueHashIdBuilder'
], (_, UpgradeBase, UniqueHashIdBuilder) => {

	/**
	 * Upgrade data item ids in dashboard spec for better performance to avoid querying same data items with different ids.
	 **/
	class DataItemIdUpgrade extends UpgradeBase {

		constructor() {
			super();
			this.VERSION = 1014;
		}

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (!spec || !spec.widgets || _.isEmpty(spec.widgets)) {
				return Promise.resolve(spec);
			}

			for (let key in spec.widgets) {
				let widget = spec.widgets[key];
				let dataViews = widget.data && widget.data.dataViews;
				if (dataViews) {
					let dataItemIdsMap = {};
					dataViews.forEach(dataView => {
						dataView.dataItems.forEach(dataItem => {
							if (dataItem.id !== '_multiMeasuresSeries') {
								dataItemIdsMap[dataItem.id] = UniqueHashIdBuilder.createUniqueHashId(dataItem.itemId, dataItemIdsMap);
							}
						});
					});
					spec.widgets[key] = this._upgradeDataItemIds(widget, dataItemIdsMap);
				}
			}

			return Promise.resolve(spec);
		}

		// Downgrades are not available in CA
		down(spec) {
			return Promise.resolve(spec);
		}

		/**
		 * Replace all the old dataItem id with the new unique hash id in the widget
		 * @param {object} widget 
		 * @param {map} dataItemIdsMap - key is dataItem.id and value is unique hash id 
		 */
		_upgradeDataItemIds(widget, dataItemIdsMap) {
			let widgetStr = JSON.stringify(widget);
			for (let key in dataItemIdsMap) {
				let re = new RegExp('"' + key + '"', 'g');
				widgetStr = widgetStr.replace(re, '"' + dataItemIdsMap[key] + '"');
			}
			return JSON.parse(widgetStr);
		}
	}

	return new DataItemIdUpgrade();
});
